module.exports = __webpack_public_path__ + "static/media/temperature.818f9a97.svg";